// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"73":"4be6e760","736":"76100bc2","980":"fe9abd18"}[chunkId] + ".js";
};